import script from "./PromotionC.vue?vue&type=script&setup=true&lang=js"
export * from "./PromotionC.vue?vue&type=script&setup=true&lang=js"

import "./PromotionC.vue?vue&type=style&index=0&id=684076da&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-684076da"]])

export default __exports__